var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconinfowarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Grupo_27582",
    "data-name": "Grupo 27582",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gem_Background_Caution",
    "data-name": "Gem Background Caution"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-2",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-3",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-4",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "#ffeedc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-5",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-6",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Gem_Background_Caution-7",
    "data-name": "Gem Background Caution",
    width: 16,
    height: 16,
    rx: 8,
    fill: "none"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_System_Warning_16px",
    "data-name": "Icon/System/Warning/16px",
    transform: "translate(2.663 3.013)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined_Shape",
    "data-name": "Combined Shape",
    d: "M1.834,9.748A1.811,1.811,0,0,1,.257,8.842,1.833,1.833,0,0,1,.238,7L3.749.923a1.819,1.819,0,0,1,3.167,0L9.635,5.633l-.577.333L6.338,1.256a1.152,1.152,0,0,0-2.009,0L.817,7.333A1.169,1.169,0,0,0,.833,8.5a1.15,1.15,0,0,0,1,.577h7A1.174,1.174,0,0,0,9.847,7.333l-.29-.506.578-.332.29.506A1.841,1.841,0,0,1,8.831,9.748Zm4.076-1.7H4.847V6.935H5.91V8.044h0Zm-.2-2.031H5.043l-.109-3H5.81l-.1,3h0Z",
    transform: "translate(0 0)",
    fill: "#b85d00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconinfowarning);
export default __webpack_public_path__ + "static/media/Iconinfowarning.201a2fe81509211849cd888b2d52e7f9.svg";
export { ForwardRef as ReactComponent };